<template>
  <v-row>
    <!-- <v-icon> mdi-filter</v-icon> -->
    <v-combobox
      v-model="selectedMeetingTypes"
      :items="meetingTypesList"
      dense
      small-chips
      class="search-bar "
      clearable
      label="Your favorite hobbies"
      multiple
      prepend-icon="mdi-filter"
      solo
      item-text="label"
      item-value="label"
      hide-details
    >
      <template v-slot:selection="{ attrs, item, selected  }">
        <v-chip
          v-bind="attrs"
          :input-value="selected"
          close
          small
          @click="select"
          @click:close="remove(item)"
        >
          <strong>{{ item.label }}</strong
          >&nbsp;
        </v-chip>
        <!-- <v-chip-group class="temp" v-if="index == 0">
          <span v-if="!selectedMeetingTypes.length">No filter applied!</span>
          <v-chip
            v-else
            light
            small
            v-for="item1 in selectedMeetingTypes"
            :key="item1.label"
            close
            :color="item1.color"
            label
            style="pointer-events: none"
          >
            {{ item1.label }}
          </v-chip>
        </v-chip-group> -->
      </template>
    </v-combobox>
    <!-- <v-combobox
      v-model="selectedMeetingTypes"
      :items="meetingTypesList"
      filled
      outlined
      rounded
      small-chips
      class="search-bar"
      deletable-chips
      color="appBar"
      item-text="label"
      item-value="label"
      multiple
      hide-details=""
      :full-width="true"
      placeholder="Filter by meeting types"
      prepend-icon="mdi-filter"
    >
      <template v-slot:selection="{ attrs, item, parent, selected }">
        <v-chip
          v-if="item === Object(item)"
          v-bind="attrs"
          :color="item.color"
          :input-value="selected"
          label
          small
          light
          style="height: 22px"
        >
          <span class="pr-2">
            {{ item.label }}
          </span>
          <v-icon small @click="parent.selectItem(item)"> $delete </v-icon>
        </v-chip>
      </template>

      <template v-slot:item="{ item }">
        <v-chip :color="item.color" label small>
          {{ item.label }}
        </v-chip>
      </template>
    </v-combobox> -->
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MeetingTypeAutocomplete",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      //   selectedMeetingTypes: [],
    };
  },
  computed: {
    ...gettersMap(),
    selectedMeetingTypes: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
  },
};

function gettersMap() {
  return mapGetters({
    meetingTypesList: "tenant/agendaMeetingTypes",
  });
}
</script>

<style>
/* .v-select__selections {
  overflow: scroll;
  flex-wrap: nowrap;
}
.v-chip {
  overflow: initial;
} */
.search-bar .v-input__slot {
  min-height: 0px !important;
  padding-top: 12px !important;
  /* align-items: stretch;
  min-width: 400px;
  max-width: 100%;
  max-height: 32px; */
  /* padding-top: 13px !important; */
}

.search-bar .v-input__slot .v-text-field input {
  padding-top: 4px;
  padding-bottom: 4px;
}

.search-bar .v-input__slot .v-input__append-outer {
   /* padding-top: 13px !important; */
}
</style>